import { render, staticRenderFns } from "./MasProCate.vue?vue&type=template&id=22ff4673&scoped=true"
import script from "./MasProCate.vue?vue&type=script&lang=js"
export * from "./MasProCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff4673",
  null
  
)

export default component.exports